import { memo } from 'react';
import IconWrapper, { IconWrapperProps } from '@repo/ui/src/components/IconWrapper';

const ExcludedIcon = (props: IconWrapperProps) => (
  <IconWrapper viewBox="0 0 24 24" width="24" height="24" title="Excluded" {...props}>
    <g clipPath="url(#clip0_315_2682)">
      <path
        d="M5.75999 5.75977L18.24 18.2398M18.24 5.75977L5.75999 18.2398"
        stroke="#727170"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_315_2682">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </IconWrapper>
);

export default memo(ExcludedIcon);
